import { usePostHog } from "posthog-js/react";
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import { usePostHogEnabled } from "./PosthogEnabled";

export const usePostHogTrackTanstackReactRouter = () => {
  const postHogEnabled = usePostHogEnabled();
  const postHog = usePostHog();
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (postHogEnabled) {
      postHog.capture("$pageview", {
        $current_url: pathname + search,
      });
    }
  }, [pathname, search, postHogEnabled, postHog]);
};
